export enum SecuritySettingsPath {
  SECURITY_SETTINGS = '',
  CONTROL_PERMISSIONS = '/control-permissions'
}
